/**
 * I moduli di contatto OMAI di questo progetto.
 *
 * Le richieste non arrivano per email: finiscono in
 * controll.omai.cloud/richieste, nella coda del modulo. Le chiavi stanno
 * scritte qui una volta sola.
 *
 * Entrambi i moduli accettano invii dal solo `https://sistemagelato.omai.cloud`.
 */
export const MODULI_BASE = 'https://link.omai.cloud';

/** Per chi potrebbe comprare il gestionale: vive nella vetrina, prima del login. */
export const MODULO_COMMERCIALE = 'commerciale-sistemagelato';

/** Per chi il gestionale ce l'ha gia': vive nell'area riservata. */
export const MODULO_ASSISTENZA = 'assistenza-sistemagelato';

/** La pagina ospitata del modulo: per i link, le email e i QR. */
export const linkModulo = (chiave: string): string => `${MODULI_BASE}/m/${chiave}`;
